




// Import the languages you want to use


import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import { Autocomplete, Box, InputLabel, MenuItem, Select, TextField } from '@mui/material'

import Stack from '@mui/material/Stack';
import { addBankAccount, fetchBankAccounts, fetchCountryList, fetchStateList } from '../../../../reducers/auth/auth.actions';

import { useDispatch, useSelector } from 'react-redux';
import ButtonGroup from '@mui/material/ButtonGroup';
import { makeStyles } from '@mui/styles'
import { selectCountryList, selectStateList } from '../../../../reducers/auth/auth.selectors';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import Loader from '../../../../components/Loader';
import BankAddesSuccesfully from './WidgetPayment/BankAddesSuccesfully';
import { useHistory } from 'react-router';
import { BANK_ACCOUNT } from 'constants/routes';

const useStyle = makeStyles({
    bankOrSwiftBtn: {
        all: 'unset',
        width: '100% !important',

        height: '40px !important',
        marginBottom: '24px'
    },

    swiftdBtn: {
        borderRadius: '0px 4px 4px 0px',
        color: '#686F8D',
        marginBottom: '16px',
        height: '40px !important',
        width: '50% !important',
        background: '#060f19',
        border: '1px solid #253245 !important',
        '&:hover, &:focus ': {
            color: '#FFFFFF',
            background: '#253245 !important'
        },
    },

    BankIdBtn: {
        borderRadius: '4px 0px 0px 4px',
        color: '#686F8D',
        border: '1px solid #253245 !important',
        height: '40px !important',
        width: '50% !important',
        background: '#060f19',
        marginBottom: '16px',
        '&:hover, &:focus': {
            color: '#FFFFFF',
            background: '#253245 !important'
        },
    },
    activeBtn: {

        borderRadius: '4px 0px 0px 4px',
        height: '40px !important',
        width: '50% !important',
        color: '#FFFFFF',
        background: 'red !important'
    },
    inputs: {
        marginBottom: '16px !important'
    },
    errors: {
        color: 'red',
        fontSize: '12px',
        paddingLeft: '8px'
    }
})

function AddBankForm() {
    const classes = useStyle()
    const [isSubmitting, setIsSubmiting] = useState(false);
    const [popupMessage, setPopupMessage] = useState('al is fine')
    const [respErrors, setRespErrors] = useState()
    const [valuess, setValuess] = useState({
        name: 'leonia'
    })
    const [addBankValue, setAddBankValue] = useState({
        'payoutInfo-payoutType': '',
        'payoutInfo-baseCurrency': 'ILS',
        'payoutInfo-nameOnAccount': '',
        'payoutInfo-bankAccountClass': '',
        'payoutInfo-bankAccountType': 'CHECKING',
        'payoutInfo-bankName': '',
        'payoutInfo-country': '',
        'payoutInfo-state': null,
        'payoutInfo-city': '',
        'payoutInfo-address': '',
        'payoutInfo-zip': '',
        'payoutInfo-bankId_or_swiftBic': true,
        'payoutInfo-bankId': '',//123123123
        'payoutInfo-swiftBic': null, //null
        'payoutInfo-bankAccountId_or_iban': true,
        'payoutInfo-iban': null,//2312312
        'payoutInfo-bankAccountId': '',//nul

        'name': '',
        'firstName': '',
        'lastName': '',
        'email': '',
        'phone': '',
        'address': '',
        'city': '',
        'country': '',
        'state': null,
        'zip': '',
        'is_business': false,
        'tax_or_vat': true,
        'taxId': '',
        'vatId': '',
        'vendorUrl': '',
        'frequency': 'MONTHLY',
        'delay': 8,

        'vendorPrincipal-firstName': '',
        'vendorPrincipal-lastName': '',
        'vendorPrincipal-address': '',
        'vendorPrincipal-address2': '',
        'vendorPrincipal-city': '',
        'vendorPrincipal-country': '',
        'vendorPrincipal-state': null,
        'vendorPrincipal-zip': '',
        'vendorPrincipal-dob': null,
        'vendorPrincipal-personalIdentificationNumber': '',
        'vendorPrincipal-driverLicenseNumber': '',
        'vendorPrincipal-passportNumber': '',
        'vendorPrincipal-email': '',
    });
    const [showPupup, setShowPupup] = useState(false);

    const dispatch = useDispatch()
    const history = useHistory();
    useEffect(() => {
        dispatch(fetchCountryList())
        dispatch(fetchStateList())
    }, [])


    const countryList = useSelector(selectCountryList)
  
    const usaStates = useSelector(selectStateList)
    const { US, CA } = usaStates

    const countryChangeHandler = (event, b) => {
        const value = b.code.toLowerCase();
        if (event.target.id.split('-')[0] === ('country' || 'state')) {
           
            setAddBankValue({
                ...addBankValue,
                [event.target.id.split('-')[0]]: value
            })
        } else {
           
            setAddBankValue({
                ...addBankValue,
                [event.target.id.split('-')[0] + '-' + event.target.id.split('-')[1]]: value
            })
        }
    }

    console.log(addBankValue);


    const changeHandler = (event) => {
        const value = event.target.value;
        setAddBankValue(
            {
                ...addBankValue,
                [event.target.name]: value
            }
        );
    }

    
    const convertToObj = () => {
        let bankData = {
            payoutInfo: {
            },
            vendorPrincipal: {
            },
        }

        for (let prop in addBankValue) {
            const [firstKey, seccondKey] = prop.split('-')

            if (seccondKey) {
                bankData = { ...bankData, [firstKey]: { ...bankData[firstKey], [seccondKey]: addBankValue[prop] } }
            } else {
                bankData[firstKey] = addBankValue[prop]
            }
        }

        return bankData
    }

    const submitHandler = (event) => {
        event.preventDefault();
        setIsSubmiting(true);
        Object.keys(addBankValue).forEach((k) => addBankValue[k] === null && delete addBankValue[k]);
        let bankData = convertToObj()

        dispatch(addBankAccount(bankData))
            .then(resp => {
                setRespErrors(false)
                setShowPupup(true)
                setIsSubmiting(false)
                setPopupMessage('Bank Account Added successfully!')
                setTimeout( () => {window.location.reload()}, 3000)
             
               
            })
            .catch(errors => {
                setShowPupup(true)
                setIsSubmiting(false)
                setRespErrors(errors?.errors)
                console.log(errors?.message, 'add bank error')
                setPopupMessage(
                    errors.message
                )
            })
            .finally(history.push(BANK_ACCOUNT));
    }

  
    return (
        <>
            <Loader isLoadin={isSubmitting} height={430} size={40}>
                <p className='main-add-bank-form'>Personal Data</p>
                <hr />
                <form onSubmit={submitHandler}>
                    <div className='main-add-bank-form'>
                        <TextField
                            type='text'
                            required
                            className={classes.inputs}
                            name="vendorPrincipal-firstName"
                            value={addBankValue['vendorPrincipal-firstName']}
                            onChange={changeHandler}
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 40 }}
                        />

                        <TextField
                            color='primary'
                            className='add-bank-inputs'
                            name="vendorPrincipal-lastName"
                            type='text'
                            required
                            value={addBankValue['vendorPrincipal-lastName']}
                            onChange={changeHandler}
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 40 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="vendorPrincipal-address"
                            type='text'
                            required
                            value={addBankValue['vendorPrincipal-address']}
                            onChange={changeHandler}
                            label="Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 60 }}
                        />

                        <TextField
                            type='text'
                            className='add-bank-inputs'
                            name="vendorPrincipal-address2"
                            value={addBankValue['vendorPrincipal-address2']}
                            onChange={changeHandler}
                            label="Address 2"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 60 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="vendorPrincipal-city"
                            type='text'
                            required
                            value={addBankValue['vendorPrincipal-city']}
                            onChange={changeHandler}
                            label="City"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 40 }}
                        />

                        <FormControl  className='add-bank-inputs' fullWidth> 
                        <InputLabel id="country-label">Choose country</InputLabel>
                            <Select
                            labelId="country-label"
                                style={{ width: "100%" }}
                                value={addBankValue['vendorPrincipal-country']}
                                label="Choose a country"
                                placeholder='Choose a country'
                                onChange={(event) => 
                                 { 
                                    setAddBankValue({...addBankValue, ['vendorPrincipal-country']: event?.target?.value?.toLowerCase()})}
                                 }

                            >
                                {!!countryList?.length &&
                                    countryList?.map(({ name, code }) => (
                                  
                                        <MenuItem key={code} value={code?.toLowerCase()}>
                                            
                                            <img
                                             className='d-flex'
                                        loading="lazy"
                                        width="20"
                                        src={`https://flagcdn.com/w20/${code?.toLowerCase()}.png`}
                                        srcSet={`https://flagcdn.com/w40/${code?.toLowerCase()}.png 2x`}
                                        alt=""
                                    />  <div className = 'ml-2 '> </div>
                                     
                                 {name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>


                        {addBankValue['vendorPrincipal-country'] === 'us' && 
                        <Autocomplete
                            type='text'
                            required
                            id='vendorPrincipal-state'
                            sx={{ width: '100%', marginBottom: '16px', p: 0 }}
                            options={US}
                            onChange={countryChangeHandler}
                            autoHighlight
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => (
                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>

                                    {option.name}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    required

                                    {...params}
                                    label="US State"
                                    sx={{ p: 0 }}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                />
                            )}
                        />
                        }

                        <TextField
                            className='add-bank-inputs'
                            name="vendorPrincipal-zip"
                            type='text'
                            required
                            value={addBankValue['vendorPrincipal-zip']}
                            onChange={changeHandler}
                            label="Zip"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 10 }}
                        />

                        <Stack component="form" noValidate spacing={3}>
                            <TextField
                                required
                                type='text'
                                className='add-bank-inputs'
                                name="vendorPrincipal-dob"
                                label="Birthday"
                                helperText={respErrors?.['vendorPrincipal.dob'] && 'Birthday field is required'}
                                error={respErrors?.['vendorPrincipal.dob']}
                                onChange={(event) => {
                                    const splitedDate = event.target.value.split('-')
                                    const dd = splitedDate[2]
                                    const mm = splitedDate[1]
                                    const yyyy = splitedDate[0]
                                    const formatedDate = `${dd}-${mm}-${yyyy}`
                                    setAddBankValue({
                                        ...addBankValue,
                                        [event.target.name]: formatedDate
                                    }
                                    )
                                }}
                                type="date"
                                value={addBankAccount['vendorPrincipal-dob']}
                                sx={{ width: '100%' }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />



                        </Stack>
                        <p className={classes.errors}></p>

                        <TextField
                            required
                            className='add-bank-inputs'
                            name="vendorPrincipal-personalIdentificationNumber"
                            value={addBankValue['vendorPrincipal-personalIdentificationNumber']}
                            onChange={changeHandler}
                            label="Personal identification number"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 25 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="vendorPrincipal-driverLicenseNumber"
                            value={addBankValue['vendorPrincipal-driverLicenseNumber']}
                            onChange={changeHandler}
                            label="Driver license number"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 20 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="vendorPrincipal-passportNumber"
                            value={addBankValue['vendorPrincipal-passportNumber']}
                            onChange={changeHandler}
                            label="Passport number"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 20 }}
                        />

                        <TextField
                            name="vendorPrincipal-email"
                            type='text'
                            required
                            value={addBankValue['vendorPrincipal-email']}
                            onChange={changeHandler}
                            label="Email"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 150 }}
                        />
                    </div>


                    <p className='main-add-bank-form'>Business info</p>
                    <div className='main-add-bank-form'>

                        <ButtonGroup
                            className={`${classes.bankOrSwiftBtn} `}
                            variant="contained">
                            <Button
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    is_business: false,
                                    name: ''
                                })}
                                className={`${addBankValue.is_business === false && 'activeBtn'} ${classes.BankIdBtn}`}

                            >
                                Individual
                     </Button>
                            <Button
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    is_business: true,
                                    firstName: '',
                                    lastName: ''

                                })}
                                className={`${addBankValue.is_business && 'activeBtn'} ${classes.swiftdBtn}`}

                            >
                                Business
                         </Button>
                        </ButtonGroup>

                        {addBankValue.is_business !== null &&
                            (

                                addBankValue.is_business ?
                                    <TextField
                                        type='text'
                                        required
                                        className='add-bank-inputs'
                                        name="name"
                                        value={addBankValue.name}
                                        onChange={changeHandler}
                                        label="Business Name"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{ maxLength: 100 }}
                                    />
                                    :
                                    (
                                        <><TextField
                                            type='text'
                                            required
                                            className='add-bank-inputs'
                                            name="firstName"
                                            value={addBankValue.firstName}
                                            onChange={changeHandler}
                                            label="First Name"
                                            variant="outlined"
                                            fullWidth
                                            error={respErrors?.firstName}
                                            helperText={respErrors?.firstName && respErrors?.firstName}
                                            inputProps={{ maxLength: 40 }}
                                        />


                                            <TextField
                                                className='add-bank-inputs'
                                                name="lastName"
                                                type='text'
                                                required
                                                value={addBankValue.lastName}
                                                onChange={changeHandler}
                                                label="Last Name"
                                                variant="outlined"
                                                fullWidth
                                                error={respErrors?.lastName}
                                                helperText={respErrors?.lastName && respErrors?.lastName}
                                                inputProps={{ maxLength: 40 }}
                                            />
                                        </>
                                    )
                            )
                        }

                        <TextField
                            className='add-bank-inputs'
                            name="email"
                            type='text'
                            required
                            value={addBankValue.email}
                            onChange={changeHandler}
                            label="Email"
                            variant="outlined"
                            fullWidth
                            error={respErrors?.email}
                            helperText={respErrors?.email && respErrors?.email}
                            inputProps={{ maxLength: 150 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="phone"
                            type='text'
                            required
                            value={addBankValue.phone}
                            onChange={changeHandler}
                            label="Phone"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 30 }}
                            helperText={respErrors?.['phone'] && 'incorrect phone format'}
                            error={respErrors?.['phone']}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="address"
                            type='text'
                            required
                            value={addBankValue.address}
                            onChange={changeHandler}
                            label="Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 60 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="city"
                            type='text'
                            required
                            value={addBankValue.city}
                            onChange={changeHandler}
                            label="City"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 40 }}
                        />

                        <TextField
                            className='add-bank-inputs'
                            name="zip"
                            type='text'
                            required
                            value={addBankValue['zip']}
                            onChange={changeHandler}
                            label="Zip"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 20 }}
                        />



<FormControl  className='add-bank-inputs' fullWidth> 
                        <InputLabel id="country-label">Choose country</InputLabel>
                            <Select
                                labelId="country-label"
                                style={{ width: "100%" }}
                                value={addBankValue['country']}
                                label="Choose a country"
                                placeholder='Choose a country'
                                onChange={(e) => setAddBankValue({...addBankValue, ['country']: e?.target?.value?.toLowerCase()})}
                                
                            >
                                {!!countryList?.length &&
                                    countryList?.map(({ name, code }) => (
                                  
                                        <MenuItem  key={code} value={code?.toLowerCase()}>
                                            
                                            <img
                                             className='d-flex'
                                        loading="lazy"
                                        width="20"
                                        src={`https://flagcdn.com/w20/${code?.toLowerCase()}.png`}
                                        srcSet={`https://flagcdn.com/w40/${code?.toLowerCase()}.png 2x`}
                                        alt=""
                                    />  <div className = 'ml-2 '> </div>
                                     
                                 {name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>


                        {addBankValue.country === 'us' && <Autocomplete
                            type='text'
                            required
                            id='state'
                            sx={{ width: '100%', marginBottom: '16px', p: 0 }}
                            options={US}
                            onChange={countryChangeHandler}
                            autoHighlight
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => (
                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>

                                    {option.name}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    required

                                    {...params}
                                    label="US State"
                                    sx={{ p: 0 }}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                />
                            )}
                        />
                        }


                        <ButtonGroup
                            className={classes.bankOrSwiftBtn}
                            variant="contained">
                            <Button
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    tax_or_vat: true,
                                    vatId: null
                                })}
                                className={`${addBankValue.tax_or_vat && 'activeBtn'} ${classes.BankIdBtn}`}
                            >
                                Tax ID
                     </Button>
                            <Button
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    tax_or_vat: false,
                                    taxId: null,

                                })}
                                className={`${addBankValue.tax_or_vat === false && 'activeBtn'} ${classes.swiftdBtn}`}
                            >
                                Vat ID
                         </Button>
                        </ButtonGroup>

                        {addBankValue.tax_or_vat !== null &&
                            (
                                addBankValue.tax_or_vat ?
                                    <TextField
                                        type='text'
                                        required
                                        className='add-bank-inputs'
                                        name="taxId"
                                        value={addBankValue.taxId}
                                        onChange={changeHandler}
                                        label="Tax ID"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{ maxLength: 18 }}
                                    />
                                    :
                                    (
                                        <><TextField
                                            type='text'
                                            required
                                            className='add-bank-inputs'
                                            name="vatId"
                                            value={addBankValue.vatId}
                                            onChange={changeHandler}
                                            label="Vat ID"
                                            variant="outlined"
                                            fullWidth
                                            inputProps={{ maxLength: 18 }}
                                        />


                                        </>
                                    )
                            )
                        }
                    </div>

                    <p className='main-add-bank-form' >payout info</p>

                    <hr />
                    <div className='main-add-bank-form'>


                        <div>
                            <FormControl required sx={{ marginBottom: '16px', width: '100%' }}>
                                <InputLabel id="demo-simple-select-autowidth-label">Payout Type</InputLabel>
                                <Select
                                    name='payoutInfo-payoutType'
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={addBankValue['payoutInfo-payoutType']}
                                    onChange={changeHandler}
                                    autoWidth
                                    required
                                    label="Payout Type"
                                >
                                    <MenuItem value={'ACH'}>ACH</MenuItem>
                                    <MenuItem value={'CHAPS'}>CHAPS</MenuItem>
                                    <MenuItem value={'FAST'}>FAST</MenuItem>
                                    <MenuItem value={'SEPA'}>SEPA</MenuItem>
                                    <MenuItem value={'WIRE'}>WIRE</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        <TextField
                            type='text'
                            required
                            className='add-bank-inputs'
                            name="payoutInfo-bankName"
                            value={addBankValue['payoutInfo-bankName']}
                            onChange={changeHandler}
                            label="Bank Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 140 }}
                        />


                        <TextField
                            type='text'
                            required
                            className='add-bank-inputs'
                            name="payoutInfo-address"
                            value={addBankValue['payoutInfo-address']}
                            onChange={changeHandler}
                            label="Bank Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 60 }}
                        />



<FormControl  className='add-bank-inputs' fullWidth> 
                        <InputLabel id="country-label">Choose country</InputLabel>
                            <Select
                                labelId="country-label"
                                style={{ width: "100%" }}
                                value={addBankValue['payoutInfo-country']}
                                label="Choose a country"
                                placeholder='Choose a country'
                                onChange={(e) => setAddBankValue({...addBankValue, ['payoutInfo-country']: e?.target?.value?.toLowerCase()})}
                                
                            >
                                {!!countryList?.length &&
                                    countryList?.map(({ name, code }) => (
                                  
                                        <MenuItem  key={code} value={code?.toLowerCase()}>
                                            
                                            <img
                                             className='d-flex'
                                        loading="lazy"
                                        width="20"
                                        src={`https://flagcdn.com/w20/${code?.toLowerCase()}.png`}
                                        srcSet={`https://flagcdn.com/w40/${code?.toLowerCase()}.png 2x`}
                                        alt=""
                                    />  <div className = 'ml-2 '> </div>
                                     
                                 {name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>


                        {addBankValue['payoutInfo-country'] === 'us' && <Autocomplete
                            type='text'
                            required
                            id='payoutInfo-state'
                            sx={{ width: '100%', marginBottom: '16px', p: 0 }}
                            options={US}
                            onChange={countryChangeHandler}
                            autoHighlight
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => (
                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>

                                    {option.name}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    required

                                    {...params}
                                    label="US State"
                                    sx={{ p: 0 }}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                />
                            )}
                        />
                        }



                        <TextField
                            type='text'
                            required
                            className='add-bank-inputs'
                            name='payoutInfo-city'
                            value={addBankValue['payoutInfo-city']}
                            onChange={changeHandler}
                            label="Bank City"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 40 }}
                        />



                        <TextField
                            type='text'
                            required
                            className='add-bank-inputs'
                            name='payoutInfo-zip'
                            value={addBankValue['payoutInfo-zip']}
                            onChange={changeHandler}
                            label="Bank Zip"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 10 }}
                        />


                        <TextField
                            type='text'
                            required
                            className='add-bank-inputs'
                            name="payoutInfo-nameOnAccount"
                            value={addBankValue['payoutInfo-nameOnAccount']}
                            onChange={changeHandler}
                            label="Name on Account"
                            variant="outlined"
                            fullWidth
                            inputProps={{ maxLength: 140 }}
                        />


                        <div>
                            <FormControl required sx={{ marginBottom: '16px', width: '100%' }}>
                                <InputLabel id="demo-simple-select-autowidth-label">Bank account class</InputLabel>
                                <Select
                                    name='payoutInfo-bankAccountClass'
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={addBankValue['payoutInfo-bankAccountClass']}
                                    onChange={changeHandler}
                                    autoWidth
                                    label="Bank account class"
                                    required
                                >

                                    <MenuItem value={'PERSONAL'}>PERSONAL</MenuItem>
                                    <MenuItem value={'CORPORATE'}>CORPORATE</MenuItem>
                                    <MenuItem value={'INTERNATIONAL'}>INTERNATIONAL</MenuItem>
                                </Select>
                                <p className={classes.errors}>{respErrors?.['payoutInfo.bankAccountClass'] && respErrors?.['payoutInfo.bankAccountClass']}</p>
                            </FormControl>
                        </div>


                        <div >
                            <p>Bank Account Type</p>
                            <RadioGroup
                                type='text'
                                sx={{ paddingTop: '12px', marginLeft: '2px', marginBottom: '16px' }}
                                name={'payoutInfo-bankAccountType'}
                                value={addBankValue['payoutInfo-bankAccountType']}
                                onChange={changeHandler}
                            >
                                <FormControlLabel sx={{ height: '24px' }} type='text' value="CHECKING" 
                                control={<Radio sx={{ color: '#B3BED1' }} />} label="Checking" />
                                <FormControlLabel sx={{ height: '24px' }} type='text' value="SAVINGS" control={<Radio sx={{ color: '#B3BED1' }} />} label="Saving" />
                            </RadioGroup>
                        </div>

                        <ButtonGroup
                            sx={{ marginTop: '24px' }}
                            className={classes.bankOrSwiftBtn}
                            variant="contained"
                        >
                            <Button
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    ['payoutInfo-bankId_or_swiftBic']: true,
                                    ['payoutInfo-swiftBic']: null
                                })}
                                className={`${addBankValue['payoutInfo-bankId_or_swiftBic'] && 'activeBtn'} ${classes.BankIdBtn}`}
                            >
                                Bank ID
                     </Button>
                            <Button
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    ['payoutInfo-bankId_or_swiftBic']: false,
                                    ['payoutInfo-bankId']: null
                                })}

                                className={`${addBankValue['payoutInfo-bankId_or_swiftBic'] === false && 'activeBtn'} ${classes.swiftdBtn}`}
                            >
                                Swift Bic
                         </Button>
                        </ButtonGroup>


                        {addBankValue['payoutInfo-bankId_or_swiftBic'] !== null &&
                            (



                                addBankValue['payoutInfo-bankId_or_swiftBic'] ?
                                    <TextField
                                        type='text'
                                        required
                                        className='add-bank-inputs'
                                        name="payoutInfo-bankId"
                                        value={addBankValue['payoutInfo-bankId']}
                                        onChange={changeHandler}
                                        label="Bank ID"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{ maxLength: 35 }}
                                    />
                                    :
                                    (
                                        <>
                                            <TextField
                                                type='text'
                                                required
                                                className={classes.inputs}
                                                name="payoutInfo-swiftBic"
                                                value={addBankValue['payoutInfo-swiftBic']}
                                                onChange={changeHandler}
                                                label="Swift Bic"
                                                variant="outlined"
                                                fullWidth
                                                error={respErrors?.['payoutInfo.swiftBic']}
                                                helperText={respErrors?.['payoutInfo.swiftBic'] && respErrors?.['payoutInfo.swiftBic']}
                                                inputProps={{ maxLength: 50 }}
                                            />
                                        </>
                                    )
                            )
                        }


                        <ButtonGroup
                            className={classes.bankOrSwiftBtn}
                            variant="contained">
                            <Button
                                className={`${addBankValue['payoutInfo-bankAccountId_or_iban'] && 'activeBtn'} ${classes.BankIdBtn}`}
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    ['payoutInfo-bankAccountId_or_iban']: true,
                                    ['payoutInfo-iban']: null
                                })}
                            >
                                Bank account ID
                     </Button>
                            <Button
                                className={`${addBankValue['payoutInfo-bankAccountId_or_iban'] === false && 'activeBtn'} ${classes.swiftdBtn}`}
                                onClick={() => setAddBankValue({
                                    ...addBankValue,
                                    ['payoutInfo-bankAccountId_or_iban']: false,
                                    ['payoutInfo-bankAccountId']: null
                                })}
                            >
                                IBAN
                         </Button>
                        </ButtonGroup>

                        {addBankValue['payoutInfo-bankAccountId_or_iban'] !== null &&
                            ( addBankValue['payoutInfo-bankAccountId_or_iban'] ?
                                    <TextField
                                        type="text"
                                        required
                                        className='add-bank-inputs'
                                        name="payoutInfo-bankAccountId"
                                        value={addBankValue['payoutInfo-bankAccountId']}
                                        onChange={changeHandler}
                                        label="Bank account ID"
                                        variant="outlined"
                                        fullWidth
                                        inputProps={{ maxLength: 34 }}
                                        
                                    />
                                    :
                                    (
                                        <>
                                            <TextField
                                                type="text"
                                                required
                                                className='add-bank-inputs'
                                                name="payoutInfo-iban"
                                                value={addBankValue['payoutInfo-iban']}
                                                onChange={changeHandler}
                                                label="IBAN"
                                                variant="outlined"
                                                fullWidth
                                                error={respErrors?.['payoutInfo.iban']}
                                                helperText={respErrors?.['payoutInfo.iban'] && respErrors?.['payoutInfo.iban']}
                                                inputProps={{ maxLength: 31 }}
                                            />

                                        </>
                                    )
                            )
                        }

                    </div>

                    <button

                        className=" add-bank-submit-btn   d-flex align-items-center justify-content-center  mx-auto  "
                        type="submit"
                        aria-controls="collapse-div"
                    // aria-expanded={open}
                    >
                        {('Save payout details')}
                    </button>
                </form>
                

                    <BankAddesSuccesfully
                        showPupup={showPupup}
                        closePopup={() => setShowPupup(!showPupup)}
                        text={popupMessage}
                        error={respErrors}
                    />

            </Loader>

        </>
    )
}

export default AddBankForm

